export const formatDateTime = (t: Function ,language: string) => {
    const date = new Date();
    const optionsDate: any = { day: 'numeric', month: 'long' };
    const optionsHour: any = { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short', hour12: false };
    const formattedDate = new Intl.DateTimeFormat(language === 'es' ? 'es-ES' : 'en-EN', optionsDate).format(date);
    const formattedHour = new Intl.DateTimeFormat(language === 'es' ? 'es-ES' : 'en-EN', optionsHour).format(date);
    const res = `${t("Dashboard.lastAccessLabel")}: ${language === 'es' ? `${formattedDate} ${date.getFullYear()}` : `${formattedDate}, ${date.getFullYear()}`} ${t("Dashboard.textAtLabel")} ${formattedHour}`
    return res;
}

export const formatHour12 = (data: any) => {
    var date = new Date('1970-01-01T' + data);
    const time = date?.toLocaleTimeString('en-EN', { hour: '2-digit', minute: '2-digit', hour12: true });
    return time;
}

export const formatScheduleTime = (data: any) => {
    const hour = data?.getHours();
    const min = data?.getMinutes();
    return `${padWithLeadingZeros(hour, 2)}:${padWithLeadingZeros(min, 2)}`;
}

const padWithLeadingZeros = (number: number, totalLength: number) => {
    return String(number).padStart(totalLength, '0');
}

export const formatStringToDate = (data: string, toLocaleDateString: boolean= false, t?: Function) => {
    if (data) {
        const lang = localStorage.getItem('LANGUAGE') || 'en';
        const date = new Date(data);
        const newDate = new Date(date.setDate(date.getDate() + 1));
        return toLocaleDateString ? newDate.toLocaleDateString(lang) : newDate
    }
    else return t ? t('Transactions.noApplyTypeLabel').toLowerCase() : ''
}

export const formatStringToDate2 = (data: string, toLocaleDateString: boolean = false, t?: Function) => {
    if (data) {
        const lang = localStorage.getItem('LANGUAGE') || 'en';
        const date = new Date(data);
        return toLocaleDateString ? date.toLocaleDateString(lang) : date
    }
    else return t ? t('Transactions.noApplyTypeLabel').toLowerCase() : ''
}

export const formatStartDateAndEndDate = (data: string, toLocaleDateString: boolean = false, t?: Function) => {
    if (data) {
        const lang = localStorage.getItem('LANGUAGE') || 'en';
        const date = new Date(data);
        const options: any = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit',
            hour12: false
        }
        return toLocaleDateString ? date.toLocaleString(lang, options).replace(',', '') : date
    }
    else return t ? t('Transactions.noApplyTypeLabel').toLowerCase() : ''
}

export const formatDateToLocale = (inputString: string, locale: string, hasYear?: boolean) => {
    const date = new Date(Date.parse(inputString));

    const options: any = {
        month: '2-digit',
        day: '2-digit',
    };

    const formattedDate = date.toLocaleDateString(locale, !hasYear && options);
    const formattedTime = date.toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    return `${formattedDate} - ${formattedTime.toUpperCase()}`;
}
